var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import MobilePage, { PageHeader } from "../../../Components/MobilePage";
import { Trans, useTranslation } from "react-i18next";
import AppBar from "../../Components/AppBar";
import useUniqueShoppingCartPictures from "@/react/Webshop/hooks/useUniqueShoppingCartPictures";
import useRetouchPictures from "@/react/Webshop/hooks/useRetouchPictures";
import useRoutes, { useHistory } from "@/react/Webshop/hooks/useRoutes";
import { useShoppingCart } from "@/react/Webshop/providers/ShoppingCartProvider";
import PictureList from "@/react/Webshop/Components/Retouch/PictureList";
import Container from "@material-ui/core/Container";
import LoadingButton from "@/react/components/LoadingButton";
import Box from "@material-ui/core/Box";
const ShoppingCartRetouch = () => {
    const { items } = useShoppingCart();
    const uniqueShoppingCartPictures = useUniqueShoppingCartPictures(items);
    const routes = useRoutes();
    const history = useHistory();
    const [t] = useTranslation();
    const { handleToggleSubProduct, product, picturesSubProducts, isUpdatingCart, updateCart, } = useRetouchPictures(uniqueShoppingCartPictures);
    if (!product) {
        return (React.createElement("div", null,
            React.createElement(Trans, null, "Retouch not available")));
    }
    const handleUpdateCart = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield updateCart();
            history.push(routes.shoppingcart.path);
        }
        catch (e) {
            console.error(e);
        }
    });
    return (React.createElement(MobilePage, { requireUser: true },
        React.createElement(AppBar, { disableBottomMargin: true }),
        React.createElement(PageHeader, null,
            React.createElement(Trans, null, "Optional retouch service")),
        React.createElement(Container, { maxWidth: "sm" },
            React.createElement("p", null, t("You have selected products with a total of %d pictures from your photo series.", {
                postProcess: "sprintf",
                sprintf: [uniqueShoppingCartPictures.length],
            })),
            React.createElement(PictureList, { pictureUuids: uniqueShoppingCartPictures, product: product, picturesSubProducts: picturesSubProducts, handleToggleSubProduct: handleToggleSubProduct }),
            React.createElement(Box, { display: "flex", justifyContent: "center" },
                React.createElement(LoadingButton, { isLoading: isUpdatingCart, size: "large", onClick: handleUpdateCart },
                    React.createElement(Trans, null, "Update cart"))))));
};
export default ShoppingCartRetouch;
